var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookinghistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2 5.5L6 9.5L10 5.5V2H2V5.5Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2 5.5L6 9.5L10 5.5V2H2V5.5Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12 0.895432 11.1046 0 10 0H2C0.895431 0 0 0.895431 0 2V4.34315C0 5.40401 0.421428 6.42143 1.17157 7.17157L4 10L1.17175 12.8424C0.427562 13.5903 0.00901189 14.602 0.00725043 15.6571L0.00334455 17.9967C0.00149831 19.1025 0.897468 20 2.00334 20H9.99666C11.1025 20 11.9985 19.1025 11.9967 17.9967L11.9927 15.6571C11.991 14.602 11.5724 13.5903 10.8282 12.8424L8 10L10.8249 7.18218C11.5772 6.43175 12 5.41281 12 4.35021V2ZM9.12132 13.6213C9.68393 14.1839 10 14.947 10 15.7426V17C10 17.5523 9.55229 18 9 18H3C2.44772 18 2 17.5523 2 17V15.7426C2 14.947 2.31607 14.1839 2.87868 13.6213L6 10.5L9.12132 13.6213ZM10 4.25736C10 5.05301 9.68393 5.81607 9.12132 6.37868L6 9.5L2.87868 6.37868C2.31607 5.81607 2 5.05301 2 4.25736V3C2 2.44772 2.44772 2 3 2H9C9.55229 2 10 2.44772 10 3V4.25736Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookinghistory);
export default __webpack_public_path__ + "static/media/booking history.f25282201b3d8c811f897abe1fe541b3.svg";
export { ForwardRef as ReactComponent };